webpackJsonp([1],{

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUGIN_NAME", function() { return PLUGIN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULTS", function() { return DEFAULTS; });
/* harmony export (immutable) */ __webpack_exports__["default"] = chatWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_body_scroll_lock__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_keyboard__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for managing the chat window UI interactions
 * @module chatWindow
 */





 // Import the Keyboard module for trap focus

var PLUGIN_NAME = 'chatWindow';
var DEFAULTS = {
  chatButton: '.js-chat-window',
  aiSuggestedQuestionClass: 'js-bedrock-question',
  chatWindowTarget: '.js-chat-window-target',
  chatWindowOverlay: '.ai-chat-window-overlay',
  chatWindowContent: '.ai-chat-window__content',
  chatWindowClose: '.js-chat-window-close',
  askAiInput: '#chat-window-input',
  askAiButton: '#js-chat-window-ask-ai',
  feedbackButton: '.js-switch-text-status',
  somethingElseButton: '.js-chat-window--something-else',
  feedbackForm: '.js-chat-feedback-form',
  conversationContainer: '#js-chat-window-conversation',
  sizeguideBtnContainer: '#js-sizeguide-target',
  feedbackContainer: '#js-switch-text-target',
  feedbackButtonContainer: '#js-feedback-button-container',
  feedbackMessageContainer: '#js-submit-feedback-container',
  pendingContainer: undefined,
  // JQuery object set in logic
  responseContainer: undefined,
  // JQuery object set in logic
  suggestionsContainer: '#js-chat-window-suggestions',
  chatIntro: '#js-chat-window-intro',
  // Leading copy shown for the initial "Something else" view
  windowHeader: '.ai-chat-window__header',
  // Chat window header selector for a11y focus
  loadingText: 'Thinking',
  activeClass: 'is-active',
  hideClass: 'u-hide',
  messageClass: 'message',
  progressClass: 'ai-chat-window__content-progress',
  bedrockSessionId: null,
  // Will be set when bedrock agent is called
  loadingIntervalId: null,
  // Will be set when animation is shown
  loadingMessage: null,
  // Will store reference to current loading message
  loadingDuration: 1500,
  loadingInterval: 500,
  maxDots: 3,
  // Function references for keyboard focus management - with safety checks
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_keyboard__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_keyboard__["a" /* default */].trapFocus ? __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_4_styleguide_modules_keyboard__["a" /* default */]) : null,
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_keyboard__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_keyboard__["a" /* default */].releaseFocus ? __WEBPACK_IMPORTED_MODULE_4_styleguide_modules_keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_4_styleguide_modules_keyboard__["a" /* default */]) : null
};

/**
 * Sets focus to the chat window header for accessibility and traps focus inside the window
 * @param {Object} opts - Options containing the window header selector
 */
function focusWindowHeader(opts) {
  // Find the window header
  var $header = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.windowHeader);

  // If header exists, set focus to it
  if ($header.length) {
    // Set tabindex if it doesn't have one already
    if (!$header.attr('tabindex')) {
      $header.attr('tabindex', '-1');
    }

    // Small delay to ensure DOM is ready and transitions are complete
    setTimeout(function () {
      $header.focus();

      // Trap focus in the chat window using jQuery object
      if (opts.chatWindowTarget && opts.trapFocusFunc && typeof opts.trapFocusFunc === 'function') {
        var $chatWindow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowTarget);
        if ($chatWindow.length) {
          opts.trapFocusFunc($chatWindow); // Pass jQuery object
        }
      }
    }, 100);
  }
}

/**
 * Opens the chat window and displays the user's question
 * @param {jQuery} $el - Chat window button element that was clicked
 * @param {Object} opts - Options passed along from initialization
 */
function openChatWindow($el, opts) {
  var buttonText = $el.text();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ai-chat-window__content-progress').addClass('ai-chat-window__content-progress--disabled');
  // Store the trigger element for focus return
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowTarget).data('lastFocusedElement', $el[0]);

  // Hide & reset feedback element
  resetFeedbackAndSuggestions(opts);

  // Open/show the chat window
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowTarget).addClass(opts.activeClass);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowOverlay).addClass(opts.activeClass);

  // Hide feedback element
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.feedbackContainer).addClass(opts.hideClass);

  // Hide suggestions based on what was asked previously
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(opts.suggestionsContainer, " ").concat(opts.chatButton, "[data-rank='").concat($el.data('rank'), "']")).addClass(opts.hideClass);

  // Lock scrolling on the body using body-scroll-lock
  var targetElement = document.querySelector(opts.chatWindowTarget);
  var scrollableContent = document.querySelector(opts.chatWindowContent);
  if (targetElement && scrollableContent) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_body_scroll_lock__["disableBodyScroll"])(scrollableContent, {
      // Pass scrollableContent instead of targetElement
      reserveScrollBarGap: true
    });
  }

  // Append question to window
  var $questionContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='ai-chat-window__content-question u-weight--bold'></div>");
  $questionContainer.append("<div class='".concat(opts.messageClass, "'><span>").concat(buttonText, "</span></div>"));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.conversationContainer).append($questionContainer);

  // Append loading container
  opts.pendingContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div></div>");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.conversationContainer).append(opts.pendingContainer);
  var showSizeguide = false;
  var rank = $el.data('rank');
  var answerClass = 'answer_' + rank;
  var recommendationsClass = 'recom_' + rank;
  // Append response and suggestions if any
  opts.responseContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(opts.hideClass, "'></div>"));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.conversationContainer).append(opts.responseContainer);
  if ($el.data('answer')) {
    var answerData = '';
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + answerClass).length > 0) {
      answerData = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + answerClass).html();
    } else {
      answerData = $el.data('answer');
      if ($el.data('sizeguide') == true && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.sizeguideBtnContainer).length) {
        answerData = answerData + '<br><br>' + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.sizeguideBtnContainer).html();
        showSizeguide = true;
      }
    }
    if (answerData.length > 0) {
      opts.responseContainer.append("<p class='".concat(answerClass, "'>").concat(answerData, "</p>"));
    }
  }
  if ($el.data('recommendationsUrl')) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + recommendationsClass).length > 0) {
      var $recommendationsContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(recommendationsClass, "'></div>"));
      opts.responseContainer.append($recommendationsContainer);
      $recommendationsContainer.html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.' + recommendationsClass).first().html());
    } else {
      var _$recommendationsContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(recommendationsClass, "'></div>"));
      opts.responseContainer.append(_$recommendationsContainer);
      showLoadingIndicator(opts);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get($el.data('recommendationsUrl'), function (data) {
        _$recommendationsContainer.html(data);
        stopLoadingAnimation(opts);
        scrollToQuestion();
        if (showSizeguide == true) {
          bindSizeGuideButton();
        }
      });
    }
  }
  var $feedbackButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.feedbackButton);
  $feedbackButton.data('question', buttonText.trim());
  $feedbackButton.data('answer', $el.data('answer'));
  $feedbackButton.data('position', $el.data('rank'));

  // Focus on the window header for accessibility and trap focus
  focusWindowHeader(opts);
  if (!$el.data('recommendationsUrl')) {
    opts.responseContainer.removeClass(opts.hideClass);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.suggestionsContainer).show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.feedbackContainer).show();
    scrollToQuestion();
    if (showSizeguide == true) {
      bindSizeGuideButton();
    }
  }
  function scrollToQuestion() {
    // Scroll to the question container
    var $scrollableContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowContent);
    if ($scrollableContent.length && $questionContainer.length) {
      var scrollTop = $questionContainer.offset().top - $scrollableContent.offset().top + $scrollableContent.scrollTop();
      $scrollableContent.animate({
        scrollTop: scrollTop - 10
      }, 150);
    }
  }
}
function bindSizeGuideButton() {
  if (typeof window.bindSizeGuideEvent === 'function') {
    window.bindSizeGuideEvent();
  }
}

/**
 * Displays a loading indicator while waiting for response
 * @param {Object} opts - Options for configuring the loading indicator
 */
function showLoadingIndicator(opts) {
  // Disable all previous loading animations by adding disabled class
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(opts.progressClass)).not('.ai-chat-window__content-progress--disabled').addClass('ai-chat-window__content-progress--disabled');

  // Create a loading message element
  var $loadingMessage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(opts.progressClass, " u-padding-rl--xl'>").concat(opts.loadingText, "</div>"));
  opts.pendingContainer.append($loadingMessage);

  // Make loading message accessible to screen readers
  $loadingMessage.attr('aria-live', 'polite');

  // Store reference to loading message for external access
  opts.loadingMessage = $loadingMessage;

  // Clear any existing interval before starting a new one
  if (opts.loadingIntervalId) {
    clearInterval(opts.loadingIntervalId);
    opts.loadingIntervalId = null;
  }

  // Animate dots
  var dots = 0;
  opts.loadingIntervalId = setInterval(function () {
    // Check if disabled class exists - if so, pause the animation
    if ($loadingMessage.hasClass('ai-chat-window__content-progress--disabled')) {
      return; // Skip this iteration, but keep interval running
    }
    dots = dots + 1 > opts.maxDots ? 1 : dots + 1;
    $loadingMessage.text("".concat(opts.loadingText).concat('.'.repeat(dots)));
  }, opts.loadingInterval);
}
function stopLoadingAnimation(options, includeFeedbackContainer) {
  // Show response after timeout
  setTimeout(function () {
    clearInterval(options.loadingIntervalId);
    options.pendingContainer.remove();
    options.responseContainer.removeClass(options.hideClass);
    if (includeFeedbackContainer) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackContainer).show();
    }
    options.pendingContainer = undefined;
    options.responseContainer = undefined;
  }, options.loadingDuration);
}

/**
 * Closes the chat window
 * @param {Object} opts - Options containing selectors and class names
 */
function closeChatWindow(opts) {
  var $chatWindow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowTarget);

  // Hide the window
  $chatWindow.removeClass(opts.activeClass);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowOverlay).removeClass(opts.activeClass);

  // Release focus trap with proper jQuery object
  if (opts.releaseFocusFunc && typeof opts.releaseFocusFunc === 'function') {
    if ($chatWindow.length && $chatWindow) {
      opts.releaseFocusFunc($chatWindow); // Pass jQuery object
    }
  }

  // Remove body scroll lock
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_body_scroll_lock__["clearAllBodyScrollLocks"])();

  // Clear any running intervals
  if (opts.loadingIntervalId) {
    clearInterval(opts.loadingIntervalId);
    opts.loadingIntervalId = null;
  }

  // Reset the containers
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.conversationContainer).empty();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(opts.suggestionsContainer, " ").concat(opts.chatButton)).removeClass(opts.hideClass);

  // Return focus to the last clicked button if it exists and is stored
  var lastFocusedElement = $chatWindow.data('lastFocusedElement');
  if (lastFocusedElement) {
    // Check if element still exists in DOM
    if (document.contains(lastFocusedElement)) {
      lastFocusedElement.focus();
    }
  }
}

/**
 * Handles the "something else" button click
 * @param {jQuery} $el - Button element that was clicked
 * @param {Object} opts - Options passed along from initialization
 */
function handleSomethingElseButton($el, opts) {
  // Store the trigger element for focus return
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowTarget).data('lastFocusedElement', $el[0]);

  // Hide & reset feedback element
  resetFeedbackAndSuggestions(opts);

  // Open/show the chat window
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowTarget).addClass(opts.activeClass);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowOverlay).addClass(opts.activeClass);

  // Show the leading copy and suggestion bubbles for the initial custom-prompt view.
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatIntro).removeClass(opts.hideClass);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.suggestionsContainer).show();

  // Lock scrolling on the body
  var targetElement = document.querySelector(opts.chatWindowTarget);
  if (targetElement) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_body_scroll_lock__["disableBodyScroll"])(targetElement);
  }

  // Focus on the window header for accessibility and trap focus
  focusWindowHeader(opts);
}
function handleAskAiButton($trigger, options) {
  var $askAiInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.askAiInput);
  var question = $askAiInput.val().trim();
  if (!question) {
    return;
  }
  logEngagementWithDetails(window.location.href, 'PDP_GenQA', 'ask_question', question);

  // Store the trigger element for focus return when closing
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowTarget).data('lastFocusedElement', $trigger[0]);

  // Hide & reset feedback element
  resetFeedbackAndSuggestions(options);

  // Append question to window
  var $questionContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<p class='ai-chat-window__content-question u-weight--bold'></p>");
  $questionContainer.append(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(options.messageClass, "'></div>")).text(question));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.conversationContainer).append($questionContainer);

  // Append loading container
  options.pendingContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div></div>");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.conversationContainer).append(options.pendingContainer);
  askBedrock(options, question);

  // Reset input val
  $askAiInput.val('');

  // Focus on the window header for accessibility and trap focus
  focusWindowHeader(options);
}
function askBedrock(options, prompt) {
  var $askAiBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.askAiButton);

  // Append response
  options.responseContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='".concat(options.hideClass, "'></div>"));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.conversationContainer).append(options.responseContainer);
  var $answerContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<p class=\"answer_\"></p>");
  options.responseContainer.append($answerContainer);
  var sessionId = getSessionId(options);
  var bedrockChatUrl = "".concat($askAiBtn.data('url'), "?prompt=").concat(encodeURIComponent(prompt)) + "&sessionId=".concat(sessionId, "&productCode=").concat(window.rcProps.pdp.code);

  // Show loading animation
  showLoadingIndicator(options);

  // Buffer the full response body before parsing. The endpoint streams the JSON
  // via a chunked ResponseBodyEmitter, so a large answer can arrive across several
  // network chunks; reading only the first chunk truncates the JSON and throws.
  fetch(bedrockChatUrl).then(function (response) {
    return response.json();
  }).then(function (data) {
    var $feedbackButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButton);
    $feedbackButton.data('question', prompt);
    $feedbackButton.data('answer', $answerContainer.text().trim());
    $answerContainer.html(data.markup);
    if (Array.isArray(data.questions) && data.questions.length) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(options.suggestionsContainer, " ").concat(options.chatButton)).addClass(options.hideClass);
      var $suggestions = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.suggestionsContainer);
      data.questions.reverse().forEach(function (question) {
        var $suggestionButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<button class="pill-button pill-button--light-grey u-margin-b--md ' + "u-flex-no-wrap u-flex u-wrap u-left ".concat(options.aiSuggestedQuestionClass, "\">"));
        $suggestionButton.text("".concat(question));
        $suggestions.prepend($suggestionButton);
      });
    }
    options.loadingDuration = 0;
    stopLoadingAnimation(options, true);
  })["catch"](function (error) {
    console.log(error);
    $answerContainer.text('Something went wrong, please try your question again. ' + 'If the problem persists, please reach out to our customer service.');
    options.loadingDuration = 0;
    stopLoadingAnimation(options, false);
  });
}
function handleFeedbackButton($trigger, options) {
  // 1. Cache selectors and initial data
  var $feedbackContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackContainer);
  var $feedbackButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButton);
  var $feedbackForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackForm);
  var $suggestionsContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.suggestionsContainer);
  var isHelpful = $trigger.data('feedback') === 1;

  // 2. Helper: Reset UI State (Use classes instead of inline CSS if possible!)
  var resetUI = function resetUI() {
    $feedbackButton.prop('disabled', false).css({
      background: "",
      borderRadius: ""
    });
    $trigger.prop('disabled', true).css({
      background: '#e4e4e4',
      borderRadius: '50%'
    });
  };

  // 3. Helper: Final Transition (The "Thank You" sequence)
  var showSuccessState = function showSuccessState() {
    $feedbackContainer.fadeOut(500, function () {
      $trigger.prop('disabled', false);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButtonContainer).addClass('u-hide');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackMessageContainer).removeClass('u-hide');
      // Reveal suggestions only once the transition has fully settled, so
      // they don't pop in mid-fade while the form/thumbs row are still moving.
      $feedbackContainer.fadeIn(500, function () {
        $suggestionsContainer.show();
      });
    });
  };

  // 4. Helper: Centralized Ajax Logic
  var sendFeedback = function sendFeedback(submissionData) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: $feedbackContainer.data('url'),
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(submissionData),
      success: function success() {
        $feedbackButton.prop('disabled', false).css({
          background: "",
          borderRadius: ""
        });
        $feedbackButton.data('question', '').data('answer', '').data('position', -1);
        if (!isHelpful) {
          $feedbackForm.fadeOut(300, function () {
            $feedbackForm.trigger("reset").addClass('u-hide');
          });
        } else {
          $feedbackForm.trigger("reset");
        }
        showSuccessState();
      }
    });
  };

  // --- Execution Logic ---
  resetUI();

  // scroll to form similar
  function scrollToForm() {
    var $chatWindowContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatWindowContent);
    var $feedbackForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackForm);
    var scrollTop = $feedbackForm.offset().top - $chatWindowContent.offset().top + $chatWindowContent.scrollTop();
    $chatWindowContent.animate({
      scrollTop: scrollTop - 10
    }, 150);
  }
  var data = {
    code: $feedbackContainer.data('code'),
    question: $trigger.data('question'),
    answer: $trigger.data('answer'),
    position: $trigger.data('position'),
    feedback: isHelpful ? 'Helpful' : 'Not Helpful'
  };
  if (!isHelpful) {
    // Show form and wait for submission
    $feedbackForm.fadeIn().removeClass('u-hide');

    // Hide questions
    $suggestionsContainer.hide();

    // Scroll to form
    scrollToForm();

    // Use .off() to ensure we don't stack multiple listeners
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off("submit", options.feedbackForm).on("submit", options.feedbackForm, function (e) {
      e.preventDefault();
      var formData = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).serializeArray();

      // Add the form data to our existing object
      sendFeedback(_objectSpread(_objectSpread({}, data), {}, {
        feedbackForm: formData
      }));
    });
  } else {
    $suggestionsContainer.show();
    // It is helpful: Hide form and send immediately
    $feedbackForm.hide();
    sendFeedback(data);
  }
}
function getSessionId(options) {
  if (options.bedrockSessionId === null) {
    options.bedrockSessionId = crypto.randomUUID();
  }
  return options.bedrockSessionId;
}
function resetFeedbackAndSuggestions(options) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackContainer).hide();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButtonContainer).removeClass('u-hide');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackMessageContainer).addClass('u-hide');
  var $feedbackButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.feedbackButton);
  $feedbackButton.prop('disabled', false).css({
    background: "",
    borderRadius: ""
  });
  $feedbackButton.data('question', '');
  $feedbackButton.data('answer', '');
  $feedbackButton.data('position', -1);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(options.aiSuggestedQuestionClass)).remove();
  // Hide the initial-view leading copy by default; it's re-shown only for that flow.
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.chatIntro).addClass(options.hideClass);
}

/**
 * Applies event handlers for chat window interactions
 * @param {jQuery} $el - Container element for the chat window
 * @param {Object} opts - Options used for configuring the chat window
 */
function applyEventHandlers($el, opts) {
  // Remove any previously bound events to prevent duplicates
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatButton).off('click.chatWindow');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click.chatWindow', ".".concat(opts.aiSuggestedQuestionClass));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowClose).off('click.chatWindow');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowOverlay).off('click.chatWindow');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.askAiButton).off('click.chatWindow');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.feedbackButton).off('click.chatWindow');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.somethingElseButton).off('click.chatWindow');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.askAiInput).off('keydown.chatWindow');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('keydown.chatWindow');

  // Regular chat window buttons (excluding "something else" buttons)
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatButton).not(opts.somethingElseButton).on('click.chatWindow', function () {
    var buttonText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text();
    openChatWindow(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), opts);
    logEngagementWithDetails(window.location.href, 'PDP_GenQA', 'click', buttonText.trim());
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.chatWindow', ".".concat(opts.aiSuggestedQuestionClass), function () {
    var buttonText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text();
    resetFeedbackAndSuggestions(opts);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(opts.suggestionsContainer, " ").concat(opts.chatButton)).addClass(opts.hideClass);

    // Append question to window
    var $questionContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<p class='ai-chat-window__content-question'></p>");
    $questionContainer.append("<div class='".concat(opts.messageClass, "'>").concat(buttonText, "</div>"));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.conversationContainer).append($questionContainer);

    // Append loading container
    opts.pendingContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div></div>");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.conversationContainer).append(opts.pendingContainer);
    askBedrock(opts, buttonText);

    // Focus on the window header for accessibility and trap focus
    focusWindowHeader(opts);
    logEngagementWithDetails(window.location.href, 'PDP_GenQA', 'click_bedrock', buttonText.trim());
  });

  // "Ask" button handling
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.askAiButton).on('click.chatWindow', function () {
    handleAskAiButton(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), opts);
  });

  // Feedback button handling
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.feedbackButton).on('click.chatWindow', function () {
    handleFeedbackButton(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), opts);
  });

  // "Something else" button handling
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.somethingElseButton).on('click.chatWindow', function () {
    handleSomethingElseButton(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), opts);
    logEngagementWithDetails(window.location.href, 'PDP_GenQA', 'ask_question', '');
  });

  // Chat window close button
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowClose).on('click.chatWindow', function () {
    closeChatWindow(opts);
  });

  // Click overlay to close - ADD THIS
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowOverlay).on('click.chatWindow', function () {
    closeChatWindow(opts);
  });
  // Input field keydown handling - Submit on Enter
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.askAiInput).on('keydown.chatWindow', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleAskAiButton(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), opts);
    }
  });

  // Handle escape key to close the chat window
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('keydown.chatWindow', function (e) {
    if (e.key === 'Escape' && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowTarget).hasClass(opts.activeClass)) {
      closeChatWindow(opts);
    }
  });

  // Handle mostly clearing bedrock agent session if any
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('beforeunload', function () {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowTarget).hasClass(opts.activeClass)) {
      closeChatWindow(opts);
    }
  });
}

/**
 * Initializes the chat window functionality
 * @param {HTMLElement} el - Container element for the chat window
 * @param {Object} options - Options used for configuring the chat window
 * @see DEFAULTS
 */
function chatWindow(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);

  // Check if already initialized to prevent multiple bindings
  if ($el.data('chatWindowInitialized')) {
    return;
  }
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);

  // Initialize a11y attributes once
  initializeA11yAttributes(opts);
  applyEventHandlers($el, opts);

  // Mark as initialized
  $el.data('chatWindowInitialized', true);
}

/**
 * Sets up accessibility attributes on the chat window elements
 * @param {Object} opts - Options containing selectors
 */
function initializeA11yAttributes(opts) {
  // Set up header for accessibility
  var $header = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.windowHeader);
  if ($header.length) {
    // Ensure the header can receive focus
    if (!$header.attr('tabindex')) {
      $header.attr('tabindex', '-1');
    }

    // Add appropriate ARIA role and label if not present
    if (!$header.attr('role')) {
      $header.attr('role', 'dialog');
    }
    if (!$header.attr('aria-labelledby') && $header.find('h2, h3, h4').length) {
      var headingId = 'chat-window-heading';
      $header.find('h2, h3, h4').first().attr('id', headingId);
      $header.attr('aria-labelledby', headingId);
    } else if (!$header.attr('aria-label')) {
      $header.attr('aria-label', 'Chat Window');
    }
  }

  // Make close button accessible
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowClose).attr('aria-label', 'Close chat window');

  // Set appropriate ARIA attributes on the chat window
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.chatWindowTarget).attr({
    'role': 'dialog',
    'aria-modal': 'true'
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, chatWindow);

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUGIN_NAME", function() { return PLUGIN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULTS", function() { return DEFAULTS; });
/* harmony export (immutable) */ __webpack_exports__["default"] = colorDropdown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/**
 * Color Dropdown jQuery Plugin
 * Handles accessible color dropdown functionality
 * @module colorDropdown
 */





// Plugin name and default options
var PLUGIN_NAME = 'colorDropdown';
var DEFAULTS = {
  colorDropdown: '.js-color-dropdown',
  colorDropdownButton: '.color-dropdown__button',
  colorDropdownList: '.color-dropdown__list',
  colorDropdownOption: '.color-dropdown__option[role="option"]',
  activeClass: 'show',
  hiddenSelect: 'select',
  animationDelay: 50
};

/**
 * Sets focus to the selected option when dropdown opens
 * @param {jQuery} $container - Dropdown container element
 * @param {Object} options - Plugin options
 */
function focusSelectedOption($container, options) {
  var $list = $container.find(options.colorDropdownList);
  var $selectedOption = $list.find('[aria-selected="true"]');
  if ($selectedOption.length) {
    // Small delay to ensure DOM is ready and transitions are complete
    setTimeout(function () {
      $selectedOption.focus();
    }, options.animationDelay);
  }
}

/**
 * Opens the color dropdown
 * @param {jQuery} $container - Dropdown container element
 * @param {Object} options - Plugin options
 */
function openDropdown($container, options) {
  var $button = $container.find(options.colorDropdownButton);
  var $list = $container.find(options.colorDropdownList);

  // Store the container for focus management
  $list.data('container', $container);

  // Set open state
  $button.attr('aria-expanded', 'true');
  $list.addClass(options.activeClass);

  // Focus selected option
  focusSelectedOption($container, options);
}

/**
 * Closes the color dropdown
 * @param {jQuery} $container - Dropdown container element
 * @param {Object} options - Plugin options
 */
function closeDropdown($container, options) {
  var $button = $container.find(options.colorDropdownButton);
  var $list = $container.find(options.colorDropdownList);

  // Remove open state
  $button.attr('aria-expanded', 'false');
  $list.removeClass(options.activeClass);

  // Clean up stored data
  $list.removeData('container');
}

/**
 * Toggles the dropdown open/closed state
 * @param {jQuery} $container - Dropdown container element
 * @param {Object} options - Plugin options
 */
function toggleDropdown($container, options) {
  var $button = $container.find(options.colorDropdownButton);
  var isOpen = $button.attr('aria-expanded') === 'true';
  if (isOpen) {
    closeDropdown($container, options);
  } else {
    openDropdown($container, options);
  }
}

/**
 * Selects a color option and updates the display
 * @param {jQuery} $container - Dropdown container element
 * @param {jQuery} $selectedOption - The option that was selected
 * @param {Object} options - Plugin options
 */
function selectOption($container, $selectedOption, options) {
  var $button = $container.find(options.colorDropdownButton);
  var $options = $container.find(options.colorDropdownOption);
  var $hiddenSelect = $container.find(options.hiddenSelect);

  // Update aria-selected
  $options.attr('aria-selected', 'false');
  $selectedOption.attr('aria-selected', 'true');

  // Update button display
  var colorClass = $selectedOption.data('color');
  var text = $selectedOption.text().trim();
  var $selectedColorCircle = $button.find('.color-dropdown__color-selected');
  var $selectedText = $button.find('.color-dropdown__option span:nth-child(2)');
  $selectedColorCircle.attr('class', "color-dropdown__color-selected ".concat(colorClass));
  $selectedText.text(text);

  // Update hidden select
  $hiddenSelect.val($selectedOption.data('value'));

  // Update tabindex for keyboard navigation
  $options.attr('tabindex', '-1');
  $selectedOption.attr('tabindex', '0');

  // Close dropdown and return focus to button
  closeDropdown($container, options);

  // Small delay to ensure dropdown is closed before focusing
  setTimeout(function () {
    $button.focus();
  }, options.animationDelay);
}

/**
 * Navigates through options using arrow keys
 * @param {jQuery} $options - All dropdown options
 * @param {string} direction - 'up' or 'down'
 */
function navigateOptions($options, direction) {
  var $focused = $options.filter(':focus');
  var currentIndex = $options.index($focused);
  var newIndex;
  if (direction === 'down') {
    newIndex = currentIndex + 1;
    if (newIndex >= $options.length) newIndex = 0;
  } else {
    newIndex = currentIndex - 1;
    if (newIndex < 0) newIndex = $options.length - 1;
  }
  $options.eq(newIndex).focus();
}

/**
 * Handles click events outside the dropdown to close it
 * @param {Event} e - Click event
 * @param {jQuery} $container - Dropdown container element
 * @param {Object} options - Plugin options
 */
function handleOutsideClick(e, $container, options) {
  if (!$container.is(e.target) && $container.has(e.target).length === 0) {
    closeDropdown($container, options);
  }
}

/**
 * Binds all event handlers for the dropdown
 * @param {jQuery} $container - Dropdown container element
 * @param {Object} options - Plugin options
 */
function bindEventHandlers($container, options) {
  var $button = $container.find(options.colorDropdownButton);
  var $options = $container.find(options.colorDropdownOption);

  // Remove any previously bound events to prevent duplicates
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click.colorDropdown');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('keydown.colorDropdown');
  $container.off('.colorDropdown');

  // Button click event
  $button.on('click.colorDropdown', function () {
    toggleDropdown($container, options);
  });

  // Button keyboard events
  $button.on('keydown.colorDropdown', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
      e.preventDefault();
      openDropdown($container, options);
    }
  });

  // Option click events
  $options.on('click.colorDropdown', function () {
    var $option = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    selectOption($container, $option, options);
  });

  // Option keyboard events
  $options.on('keydown.colorDropdown', function (e) {
    var $option = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      selectOption($container, $option, options);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      navigateOptions($options, 'down');
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      navigateOptions($options, 'up');
    } else if (e.key === 'Escape') {
      e.preventDefault();
      closeDropdown($container, options);
      $button.focus();
    }
  });

  // Global event handlers
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.colorDropdown', function (e) {
    handleOutsideClick(e, $container, options);
  });

  // Handle escape key globally
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('keydown.colorDropdown', function (e) {
    if (e.key === 'Escape') {
      var _$button = $container.find(options.colorDropdownButton);
      var isOpen = _$button.attr('aria-expanded') === 'true';
      if (isOpen) {
        closeDropdown($container, options);
        _$button.focus();
      }
    }
  });
}

/**
 * Sets up accessibility attributes on dropdown elements
 * @param {jQuery} $container - Dropdown container element
 * @param {Object} options - Plugin options
 */
function initializeA11yAttributes($container, options) {
  var $button = $container.find(options.colorDropdownButton);
  var $list = $container.find(options.colorDropdownList);
  var $options = $container.find(options.colorDropdownOption);

  // Set up button accessibility
  if (!$button.attr('aria-haspopup')) {
    $button.attr('aria-haspopup', 'listbox');
  }
  if (!$button.attr('aria-expanded')) {
    $button.attr('aria-expanded', 'false');
  }

  // Set up list accessibility
  if (!$list.attr('role')) {
    $list.attr('role', 'listbox');
  }

  // Generate unique IDs for aria-controls if needed
  var listId = $list.attr('id');
  if (!listId) {
    listId = "color-dropdown-list-".concat(Math.random().toString(36).substr(2, 9));
    $list.attr('id', listId);
  }
  $button.attr('aria-controls', listId);

  // Set up option accessibility
  $options.each(function () {
    var $option = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (!$option.attr('tabindex')) {
      var isSelected = $option.attr('aria-selected') === 'true';
      $option.attr('tabindex', isSelected ? '0' : '-1');
    }
  });
}

/**
 * Main plugin initialization function
 * @param {HTMLElement} el - The dropdown container element
 * @param {Object} userOptions - User-provided options
 * @returns {jQuery} The jQuery element for chaining
 */
function colorDropdown(el) {
  var userOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);

  // Prevent multiple initializations
  if ($element.data(PLUGIN_NAME + 'Initialized')) {
    return $element;
  }

  // Merge default options with user options
  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, userOptions, $element);

  // Initialize accessibility attributes
  initializeA11yAttributes($element, options);

  // Bind event handlers
  bindEventHandlers($element, options);

  // Mark as initialized
  $element.data(PLUGIN_NAME + 'Initialized', true);

  // Store options for later access
  $element.data(PLUGIN_NAME + 'Options', options);

  // Return element for chaining
  return $element;
}

// Register as jQuery plugin
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, colorDropdown);

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(0);
var defaults = __webpack_require__(30);
module.exports = horizontalScrollMenu;
function horizontalScrollMenu(targetElement, options) {
  options = options || {};
  defaults(options, {
    //selectedClassName: 'selected'
    fixed: true,
    scrollMenu: '.js-scroll-menu',
    scrollItem: '.scroll-menu__item',
    scrollItemActive: 'scroll-menu__item--active',
    scrollMenuFixed: 'scroll-menu--fixed',
    speed: 200
  });

  //Apply active class for styling (mobile)
  $(options.scrollItem).on("click", function () {
    var thisItem = $(this);
    thisItem.siblings().removeClass(options.scrollItemActive).end().addClass(options.scrollItemActive);
  });

  //Fix Designer Menu header on scroll
  var fixedMenu = function fixedMenu() {
    if (options.fixed) {
      var element = $(options.scrollMenu);
      var elementHeight = $(element).outerHeight(true);
      var scrollPosY = $(window).scrollTop();
      var elementOffset = $(element).offset().top + elementHeight;
      var distance = elementOffset - scrollPosY;
      var $atbButton = $('#add-to-bag-btn').offset().top;
      var $atbHeight = $('#add-to-bag-btn').outerHeight();
      if (scrollPosY > $atbButton + $atbHeight) {
        element.addClass(options.scrollMenuFixed);
      } else {
        element.removeClass(options.scrollMenuFixed);
      }
    }
  };

  //Adjust anchor scroll based on fixed header
  var adjustAnchor = function adjustAnchor() {
    var $anchor = $(':target');
    var element = $(options.scrollMenu);
    var elementHeight = $(element).outerHeight(true);
    if ($anchor.length > 0) {
      $('html, body').stop().animate({
        scrollTop: $anchor.offset().top - elementHeight
      }, options.speed);
    }
  };
  $(window).on('scroll resize', fixedMenu);
  $(window).on('hashchange load', adjustAnchor);
} //End horizontalScrollMenu

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);



var PLUGIN_NAME = 'notifyMe';
var DEFAULTS = {};
var validateEmail = function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};
var setEventListeners = function setEventListeners($el, opts) {
  $el.on('click', function () {
    var $emailInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-bis-email');
    var $phoneInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-modal-bis-phone');
    var $bisContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-bis-input-container');
    var $duplicateInquiry = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-duplicate-inquiry');
    $bisContainer.removeClass('is-error');
    if (!$duplicateInquiry.hasClass('u-hide')) {
      $duplicateInquiry.addClass('u-hide');
    }
    if (!validateEmail($emailInput.val())) {
      $bisContainer.addClass('is-error');
      $emailInput.focus();
      setTimeout(function () {
        $el.progressiveButton('reset');
      }, 400);
      return;
    }
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      size: $el.data('size'),
      email: $emailInput.val(),
      phone: $phoneInput.val(),
      code: $el.data('code'),
      allowDuplicate: false
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post('/r/ajax/SubmitFindSizeInquiry.jsp', data, function (msg) {
      var result = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(msg);
      if (result.success) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-thank-you-email').html($emailInput.val());
        $bisContainer.addClass('u-hide');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-thank-you-container').removeClass('u-hide');
      } else {
        if (result.duplicate) {
          $duplicateInquiry.removeClass('u-hide');
        }
      }
      $el.progressiveButton('reset');
    });
    logEngagementWithDetails(window.location.href, 'oos similar recs', 'submit notify me', $el.data('code'));
  });
};
function notifyMe(el, options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-modal-bis-phone').mask('(000) 000-0000');
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, notifyMe);

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StickyAddToBag = /*#__PURE__*/function () {
  function StickyAddToBag() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, StickyAddToBag);
    this.config = {
      originalButtonSelector: options.originalButtonSelector || "#add-to-bag-btn",
      zIndex: options.zIndex || 9999,
      buffer: options.buffer || 0
    };
    this.originalButton = null;
    this.stickyContainer = null;
    this.isStickyVisible = false;
    this.hasScrolledPastButton = false; // Track if user has seen the button
    this.isBlocked = false;
    this.init();
  }
  return _createClass(StickyAddToBag, [{
    key: "init",
    value: function init() {
      // Find the original button
      this.originalButton = document.querySelector(this.config.originalButtonSelector);
      if (!this.originalButton) {
        console.warn("StickyAddToBag: original button not found");
        return;
      }

      // Create sticky container
      this.createSticky();

      // Bind scroll and resize
      this.bindEvents();

      // Initial update
      this.updateSticky();
    }
  }, {
    key: "createSticky",
    value: function createSticky() {
      var _this = this;
      this.stickyContainer = document.createElement("div");
      this.stickyContainer.className = "sticky-add-to-bag-container";

      // Clone original button
      var clone = this.originalButton.cloneNode(true);
      clone.removeAttribute("id");
      clone.querySelectorAll("[id]").forEach(function (el) {
        return el.removeAttribute("id");
      });
      clone.classList.remove("btn--lg");
      clone.classList.add("btn--md");
      clone.classList.add("sticky-add-to-bag");
      this.stickyContainer.appendChild(clone);
      document.body.appendChild(this.stickyContainer);

      // Apply styles
      this.stickyContainer.style.cssText = "\n\t\t\tposition: fixed;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\tbackground: #fff;\n\t\t\tz-index: ".concat(this.config.zIndex, ";\n\t\t\ttransform: translateY(100%);\n\t\t\ttransition: transform 0.25s ease;\t\n\t\t");
      clone.addEventListener("click", function (e) {
        e.preventDefault();

        // Trigger original button click
        _this.originalButton.click();

        // Scroll to first invalid field if there is one
        var firstInvalid = document.querySelector(":invalid");
        if (firstInvalid) {
          var offset = 80; // optional offset for sticky height
          var y = firstInvalid.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({
            top: y,
            behavior: "smooth"
          });

          // Focus field without scrolling again
          firstInvalid.focus({
            preventScroll: true
          });
        }
      });
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this2 = this;
      var ticking = false;
      this.scrollHandler = function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            _this2.updateSticky();
            ticking = false;
          });
          ticking = true;
        }
      };
      window.addEventListener("scroll", this.scrollHandler, {
        passive: true
      });
      window.addEventListener("resize", this.scrollHandler, {
        passive: true
      });
      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", this.scrollHandler);
        window.visualViewport.addEventListener("scroll", this.scrollHandler);
      }
    }
  }, {
    key: "updateSticky",
    value: function updateSticky() {
      var _window$visualViewpor;
      var button = document.querySelector(this.config.originalButtonSelector);
      if (!button) {
        console.warn("Button lost during scroll!");
        return;
      }
      var rect = button.getBoundingClientRect();
      var viewportHeight = ((_window$visualViewpor = window.visualViewport) === null || _window$visualViewpor === void 0 ? void 0 : _window$visualViewpor.height) || window.innerHeight;
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;

      // Fallback calculations if getBoundingClientRect fails
      var isAboveViewport, isBelowViewport, isInViewport;
      if (rect.width === 0 && rect.height === 0) {
        // Use offset calculations
        var buttonOffsetTop = button.offsetTop;
        var buttonHeight = button.offsetHeight;
        var buttonTopRelativeToViewport = buttonOffsetTop - scrollY;
        var buttonBottomRelativeToViewport = buttonOffsetTop + buttonHeight - scrollY;
        isAboveViewport = buttonBottomRelativeToViewport < this.config.buffer;
        isBelowViewport = buttonTopRelativeToViewport > viewportHeight - this.config.buffer;
        isInViewport = !isAboveViewport && !isBelowViewport;
      } else {
        // Normal calculations
        isAboveViewport = rect.bottom <= this.config.buffer;
        isBelowViewport = rect.top >= viewportHeight - this.config.buffer;
        isInViewport = rect.top < viewportHeight && rect.bottom > 0;
      }

      // Track if user has ever scrolled past the button (seen it)
      if (isInViewport || isAboveViewport) {
        this.hasScrolledPastButton = true;
      }

      // Only show sticky if:
      // 1. User has scrolled past the button at least once
      // 2. Button is currently above the viewport
      var shouldShow = this.hasScrolledPastButton && isAboveViewport;
      if (this.isBlocked) {
        if (this.isStickyVisible) {
          this.hideSticky();
        }
        return;
      }
      if (shouldShow && !this.isStickyVisible) {
        this.showSticky();
      } else if (!shouldShow && this.isStickyVisible) {
        this.hideSticky();
      }
    }
  }, {
    key: "showSticky",
    value: function showSticky() {
      this.isStickyVisible = true;
      this.stickyContainer.style.transform = "translateY(0)";
    }
  }, {
    key: "hideSticky",
    value: function hideSticky() {
      this.isStickyVisible = false;
      this.stickyContainer.style.transform = "translateY(100%)";
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("scroll", this.scrollHandler);
      window.removeEventListener("resize", this.scrollHandler);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", this.scrollHandler);
        window.visualViewport.removeEventListener("scroll", this.scrollHandler);
      }
      if (this.stickyContainer) {
        this.stickyContainer.remove();
      }
    }
  }, {
    key: "block",
    value: function block() {
      this.isBlocked = true;
      this.hideSticky();
    }
  }, {
    key: "unblock",
    value: function unblock() {
      this.isBlocked = false;
      this.updateSticky();
    }
  }]);
}(); // Export as ES module
/* harmony default export */ __webpack_exports__["a"] = (StickyAddToBag);

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setupStyliticsToggle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

function setupStyliticsToggle($selector) {
  if (!$selector) {
    return;
  }
  $selector.on('click', function (e) {
    var url = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("styliticsShop");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'POST',
      url: url,
      success: function success(data) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shop-this-look").html(data);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shop-this-look").removeClass("u-hide");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#global-nav-div").addClass("u-hide");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-pdp_main").addClass("u-hide");
        window.scrollTo(0, 0);
        var jsElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#shop-this-look").find('.js-horizontal-scroll');
        if (jsElement.length) {
          jsElement.horizontalScroll();
        }
      }
    });
  });
}

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/*! jQuery & Zepto Lazy - YouTube Plugin v1.5 - http://jquery.eisbehr.de/lazy - MIT&GPL-2.0 license - Copyright 2012-2018 Daniel 'Eisbehr' Kern */
!function (t) {
  t.lazy(["yt", "youtube"], function (t, e) {
    if ("iframe" === t[0].tagName.toLowerCase()) {
      var o = /1|true/.test(t.attr("data-nocookie"));
      t.attr("src", "https://www.youtube" + (o ? "-nocookie" : "") + ".com/embed/" + t.attr("data-src") + "?rel=0&amp;showinfo=0"), this.config("removeAttribute") && t.removeAttr("data-src");
    } else e(!1);
  });
}(window.jQuery || window.Zepto);

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notify_me__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_heart_product__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bis_and_so__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stylitics_toggle__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__add_to_bag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vendor_jquery_lazy_youtube_min__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vendor_jquery_lazy_youtube_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vendor_jquery_lazy_youtube_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_preload_markup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_add_to_bag__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_revieve_try_on__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_revieve_makeup_advisor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_social_proof__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_global_log_engagement__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sticky_add_to_bag__ = __webpack_require__(188);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }














var horizontalScrollMenu = __webpack_require__(186);
var chatWindowQa = __webpack_require__(184);
var colorDropdown = __webpack_require__(185);
window.productHearts = {};
window.setupBisAndSo = __WEBPACK_IMPORTED_MODULE_3__bis_and_so__["a" /* default */];
window.setupStyliticsToggle = __WEBPACK_IMPORTED_MODULE_4__stylitics_toggle__["a" /* default */];
window.addToBagWithData = function (data, callbacks, addToBagUrl) {
  if (data.fromZelig) {
    callbacks = {};
    callbacks.success = function () {
      insertPageTrackForMobileWithData({
        addToCartFlag: true,
        productCode: data.code,
        isZeligAddToBag: true
      });
    };
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_modules_add_to_bag__["a" /* addToBagWithData */])(data, callbacks, addToBagUrl);
};
function getSelectedSize() {
  var size = '';
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-size-options').length) {
    var $checkedSizeOption = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-size-options input:checked');
    if ($checkedSizeOption.length) {
      size = $checkedSizeOption.val();
    }
  } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products').length) {
    size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products option:selected').val();
  } else {
    var selectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size');
    if (selectedSize.is(':visible')) {
      size = selectedSize.val();
    }
  }
  return size;
}
function initHorizontalScrollMenu() {
  horizontalScrollMenu();
}
function addToFavorites(pcode, favorited, callBack) {
  var selectedSize = getSelectedSize();
  var isGuest = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myFavLimitPopup').data('isGuest');
  var productSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr_top_heart_mhp_count').data('count');
  if (isGuest) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#guestLimitPop, #fav-create-link').attr('href', '/r/mobile/LoginPage.jsp?favcode=' + pcode + '&ref=' + encodeURIComponent(window.location.pathname + window.location.search));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      triggerOpen: true,
      open: 'guestLimitPop'
    });
    return;
  } else if (!isGuest && productSize > 1999) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      triggerOpen: true,
      open: 'userLimitPop'
    });
    return;
  }
  if (favorited) {
    __WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */].submitHeart('product', pcode, 'add', selectedSize, null, callBack);
    window.productHearts[pcode] = true;
  } else {
    __WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */].submitHeart('product', pcode, 'remove', selectedSize, null, callBack);
    window.productHearts[pcode] = false;
  }
}
window.addFavEvent = function addFavEvent(el) {
  if (!el) return;
  el.addEventListener('favorite', function (e) {
    var pcode = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code');
    var favorited = e.detail.favorited;
    var callBack = e.detail.callback;
    addToFavorites(pcode, favorited, callBack);
  });
};
var sizeNotSelectedBeforeAddingToBag = false;
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('change', '#size', function () {
  if (sizeNotSelectedBeforeAddingToBag) {
    var addToBagButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#add-to-bag-btn:visible');
    if (addToBagButton.length > 0) {
      window.addToBag(addToBagButton);
    }
    sizeNotSelectedBeforeAddingToBag = false;
  }
});
window.bindSizeGuideEvent = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-size-guide-modal').on('click', function () {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('fitPredictorCode') && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('showDynamicSizeGuide')) {
      ssp('start', 'sizeguide');
      ssp('track', 'triggerSizeGuide', {
        productId: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('fitPredictorCode'),
        origin: 'sizeguide-cta'
      });
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: "".concat(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('url')),
      triggerOpen: true,
      type: 'full',
      triggerElement: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)
    });
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.view_size_guide').click(function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'PDP Size Click', 'Click', 'View Size Guide');
  });
};
document.addEventListener("DOMContentLoaded", function () {
  // const SHOW_IMAGES = rcProps.yotpo.showReviewImages;
  var srProcessed = false;
  var fullProcessed = false;
  var observer = new MutationObserver(function (mutationsList, observer) {
    var widgetElement = document.querySelector('.yotpo-widget-instance');
    if (!widgetElement) return;

    // check if product has yotpo reviews or 0. Hide if 0.
    if (!srProcessed) {
      var $srReviewText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel');
      if ($srReviewText.length) {
        var _$srReviewText$text$m;
        srProcessed = true;
        var reviewCount = parseInt(((_$srReviewText$text$m = $srReviewText.text().match(/\d+/)) === null || _$srReviewText$text$m === void 0 ? void 0 : _$srReviewText$text$m[0]) || '0', 10);
        if (reviewCount === 0) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.yotpo-widget-instance').has('.yotpo-sr-bottom-line-text--right-panel').hide();
        }
      }
    }
    if (fullProcessed) return;
    var fullText = document.querySelector('.yotpo-bottom-line-basic-text');
    if (!fullText) return;
    fullProcessed = true;

    // extract only numbers from fullText
    if (document.querySelector('.yotpo-widget-instance.ab929')) {
      var _fullText$textContent;
      var fullTextReviewNum = (fullText === null || fullText === void 0 || (_fullText$textContent = fullText.textContent.match(/[\d,]+/)) === null || _fullText$textContent === void 0 ? void 0 : _fullText$textContent[0]) || '';
      var productReviewAccordionText = document.querySelector('#product-reviews .accordion__label-text');
      productReviewAccordionText.textContent = "".concat(productReviewAccordionText.textContent, " (").concat(fullTextReviewNum, ")");
      fullText.textContent = "".concat(fullTextReviewNum, " Review").concat(fullTextReviewNum !== '1' ? 's' : '');
    }
    var widgetElementDetailsMarkup = document.querySelector('#detailsMarkup .yotpo-widget-instance');
    if (widgetElementDetailsMarkup) {
      widgetElementDetailsMarkup.style.display = 'none';
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-scroll-menu').length) {
      initHorizontalScrollMenu();
    }
    observer.disconnect();
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
if (rcProps.abtests.personalizedPla) {
  window.stickyATB = new __WEBPACK_IMPORTED_MODULE_13__sticky_add_to_bag__["a" /* default */]();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.js-personalized-pla-tag', function () {
    var tag = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('personalized-pla-tag');
    if (tag && tag.toString().trim() !== '') {
      var params = new URLSearchParams(window.location.search);
      params.set("selectedPlaTag", tag); // safely adds/updates
      window.history.pushState({}, '', "".concat(window.location.pathname, "?").concat(params.toString()));
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.js-personalized-pla-more', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var productCode, container, tag, index, list, url, res, html, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          productCode = document.querySelector('.js-personalized-pla-container').dataset.personalizedPlaCode;
          container = document.querySelector('.js-personalized-pla-tagged-tab.tabs__content--active');
          tag = container.dataset.personalizedPlaTag;
          index = container.querySelectorAll('.js-personalized-pla-tagged-tab-cell').length;
          list = container.querySelector('ul');
          url = new URL('/content/personalized-pla/' + productCode + '/view-more/', window.location.origin);
          url.searchParams.set('selectedPlaTag', tag);
          url.searchParams.set('index', index);
          _context.n = 1;
          return fetch(url.toString());
        case 1:
          res = _context.v;
          _context.n = 2;
          return res.text();
        case 2:
          html = _context.v;
          list.insertAdjacentHTML('beforeend', html);
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error(_t);
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[0, 3]]);
  })));
}
window.initPDPJs = function (codeForInitJs) {
  var slideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-pdp-beauty-video-slideshow');
  slideshow.removeClass('slick-slideshow--js-trigger');
  slideshow.slick({
    arrows: false,
    dots: true,
    infinite: true,
    mobileFirst: true,
    autoplay: false,
    slidesToShow: 1,
    speed: 200,
    lazyLoad: 'progressive',
    touchThreshold: 20
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').horizontalScroll();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-chat-window').chatWindow();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-color-dropdown').colorDropdown();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-accordion').accordion();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal').modal();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-track-video').trackVideo();
  window.resetLazyLoad();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').toggleFavorite();
  window.addFavEvent(document.querySelector('.js-fav-button'));
  window.setupImageCarousel();
  window.setupStyliticsToggle(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('ul.image-carousel li.image-carousel__item--stylitics a[data-stylitics-shop]'));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-change').toggleChange();
  window.setupBisAndSo();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#add-to-bag-form').submit(function (e) {
    e.preventDefault();
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tabs-size-guide').tabs({
    tab: '.tabs-size-guide__link',
    tabActive: 'tabs-size-guide__link--active',
    tabContentActive: 'sizeguide-tab-content--active'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size').on('invalid', function (e) {
    e.preventDefault();
  }).on('change', function () {
    var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $oosButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#oos-submit');
    var $selectedOption = $this.find('option:selected');
    var code = $selectedOption.data('code');
    if ($selectedOption.data('isSeparateProductCode')) {
      return; // this is handled as if it's a color change to fit in better with the AJAX retrieval
    }
    if (this.value) {
      var url = window.location.href;
      var r = new URL(url);
      r.searchParams.set('size', this.value);
      if (code !== undefined) {
        r.searchParams.set('product', code);
      }
      url = r.href;
      window.history.replaceState(null, document.title, url);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: 'POST',
        data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
          url: url,
          module: 'PDP Size Click',
          action: 'Click',
          details: this.value
        }),
        url: '/r/ajax/LogEngagement.jsp'
      });
      var otherColorsOosForSize = $selectedOption.data('colorsOos');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-color-option').each(function (index, el) {
        var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
        $el.text($el.data('defaultText'));
      });
      if (otherColorsOosForSize) {
        for (var i = 0; i < otherColorsOosForSize.length; i++) {
          var otherColorCode = otherColorsOosForSize[i];
          var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#color-option-".concat(otherColorCode));
          if ($el && $el.data('oosText')) {
            // https://stackoverflow.com/a/22706073
            var elementForEncoding = document.createElement('p');
            elementForEncoding.innerHTML = this.value;
            $el.html("".concat($el.data('oosText').replace('<size>', elementForEncoding.innerHTML)));
          }
        }
      }
      var _$fitPredictorRoot = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fp-root');
      if (_$fitPredictorRoot.length) {
        var productData = ssp('get', 'product', _$fitPredictorRoot.data('productId')) || {};
        productData.size = this.value;
        productData.price = $selectedOption.data('price');
        if ($selectedOption.data('regularPrice') !== $selectedOption.data('price')) {
          productData.salePrice = $selectedOption.data('price');
        }
        productData.variantId = code + '_' + this.value;
        ssp('set', 'product', productData);
      }
      var oosNotifyRecommendationsModalHref = $selectedOption.data('notifyRecommendationsUrl');
      if (oosNotifyRecommendationsModalHref) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          url: oosNotifyRecommendationsModalHref,
          triggerOpen: true,
          type: 'toast',
          onComplete: function onComplete() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-horizontal-scroll').horizontalScroll();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */])('.js-similar-page-items', '.js-favorite-button');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-favorite-button').on('click', function () {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'oos similar recs', 'heart', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('pcode'));
            });
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-progressive-button').progressiveButton();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-bis-notify-me').notifyMe();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-bag').on('click', function () {
              var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__add_to_bag__["a" /* addToBag */])($el.data('code'), $el.data('size'), null, {
                showJustAdded: false
              });
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'oos similar recs', 'atc', $el.data('code'));
            });
          }
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'oos similar recs', 'open recs', "".concat(code, "+").concat(this.value));
      }
    }
    if ($oosButton.length > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#product-info-form').removeClass('product__information--placeholder');
    }
  });
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products').length > 0) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products').on('invalid', function (e) {
      e.preventDefault();
    });
  }
  function getHTMLJSSaveId(value) {
    return value.toString().replace(/[\W_]+/g, '');
  }
  window.setUpProductHandlers();
  var $product = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product');
  $product.find('#product-swatches input').change(function () {
    var href = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-href');
    if (href != '') {
      location.href = href;
    }
  });
  $product.find('#pdp-size-options input').change(function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var dataSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(obj).data('size');
    var oneLeft = el.data('oneLeft');
    var finalSale = el.data('finalSale');
    var isPreorder = el.data('preorder');
    var isOos = el.data('oos');
    var defectiveDisclaimer = el.data('defect-disclaimer');
    var inventoryDisclaimer = el.data('inventory-disclaimer');
    var sizeLabel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label');
    sizeLabel.removeClass('u-error');
    sizeLabel.html(el.data('size-label'));
    var showAfterPay = true;
    var showKlarna = true;
    if (isPreorder) {
      sizeLabel.html(el.data('size-label') + ' ' + sizeLabel.data('preorder'));
      showAfterPay = false;
      showKlarna = false;
    }
    if (oneLeft) {
      var oneLeftMsg = sizeLabel.data('one-left');
      if (isPreorder) {
        sizeLabel.html("".concat(sizeLabel.html(), " <span class='u-error'>").concat(oneLeftMsg, "</span>"));
      } else {
        sizeLabel.html("".concat(el.data('size-label'), " <span class='u-error'>").concat(oneLeftMsg, "</span>"));
      }
    }
    if (isOos) {
      showAfterPay = false;
      showKlarna = false;
    }
    if (document.getElementById('afterPayBox')) {
      if (showAfterPay) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#afterPayBox').show();
        if (dataSize !== '') {
          var afterPayMessageBySize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#afterPayBox' + getHTMLJSSaveId(dataSize));
          if (afterPayMessageBySize.length) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.afterPayBoxMsg').hide();
            afterPayMessageBySize.show();
          }
        }
      } else __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#afterPayBox').hide();
    }
    if (document.getElementById('klarnaPayMsgOption')) {
      if (showKlarna) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#klarnaPayMsgOption').show();
        if (dataSize !== '') {
          var klarnaMessageBySize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#installmentPlanMsg' + getHTMLJSSaveId(dataSize));
          if (klarnaMessageBySize.length) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.installmentPlanBoxMsg').hide();
            klarnaMessageBySize.show();
          }
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#klarnaPayMsgOption').hide();
      }
    }
  });
  var selectedInput = $product.find('#pdp-size-options input:checked');
  if (selectedInput.length > 0) {
    selectedInput.trigger('change');
    selectedInput.trigger('click');
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size').change();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel').on('afterChange', function () {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.slick-active > .image-carousel__vid-container').length > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.slick-active > .image-carousel__vid-container').addClass('image-carousel__vid-container--center');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product-badge').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shop-the-look').hide();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product-badge').show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shop-the-look').show();
    }
  });
  var logEngagement = function logEngagement(module, action, details) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'POST',
      data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        url: window.location.href,
        module: module,
        action: action,
        details: details
      }),
      url: '/r/ajax/LogEngagement.jsp'
    });
  };
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-pdp-video').lazy({
    afterLoad: function afterLoad(element) {
      var src = element.attr('src');
      var muted = element.data('mute');
      if (muted === true) {
        element.attr('src', src + '&mute=1');
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-track-size-fit-tab').click(function () {
    logEngagement('Size Fit Tab', 'Click');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-play-video-btn-update').on('click', function () {
    var video = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('video').get(0);
    video.play();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-play-video-btn-update .video__play-icon').hide();
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-play-video-btn').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: '/content/video/beauty/modal',
      data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        videoId: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('videoId')
      }),
      video: true,
      triggerOpen: true
    });
  });
  var pdpProps = window.rcProps.pdp || {};
  var productCodes = pdpProps.productCodes || [];
  if (productCodes && productCodes.length > 0) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      type: 'GET',
      url: '/r/ajax/GetProductData.jsp',
      data: {
        product: productCodes,
        department: pdpProps.department
      },
      success: function success(rtn) {
        var data = parseRtn(rtn);
        var productData = data[pdpProps.code];
        var sizes = productData['inventory'];
        var otherCodesOutOfStockBySize = sizes.reduce(function (result, item) {
          result[item['size']] = [];
          return result;
        }, {});
        for (var i = 0; i < productCodes.length; i++) {
          var colorwayCode = productCodes[i];
          if (colorwayCode === pdpProps.code) {
            continue;
          }
          if (data[colorwayCode]) {
            var colorwaySizes = data[colorwayCode]['inventory'];
            if (colorwaySizes) {
              for (var j = 0; j < colorwaySizes.length; j++) {
                var colorwaySize = colorwaySizes[j];
                var oos = colorwaySize['quantity'] === 0;
                if (oos) {
                  var sizesOos = otherCodesOutOfStockBySize[colorwaySize['size']];
                  if (sizesOos) {
                    sizesOos.push(colorwayCode);
                  }
                }
              }
            }
          }
        }
        for (var _i = 0; _i < sizes.length; _i++) {
          var size = sizes[_i]['size'];
          var optionInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-option-".concat(sizes[_i]['sizeForId']));
          var otherCodesOos = otherCodesOutOfStockBySize[size];
          if (optionInput) {
            optionInput.data('colorsOos', otherCodesOos);
          }
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size').trigger('change'); // in case a size has already been selected (e.g., pre-selected size)
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shop-the-look').on('click', function (e) {
    e.preventDefault();
    if (typeof logEngagement === 'function') logEngagement(window.location.href, 'shop_the_look', 'click');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('styliticsUrl'),
      type: 'toast',
      triggerOpen: true,
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-progressive-button').progressiveButton();
      },
      onLoad: function onLoad() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal__content').addClass('u-padding-r--none').find('.js-horizontal-scroll').horizontalScroll();
      }
    });
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-view-review').click(function (e) {
    e.preventDefault();
    var url = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: url,
      type: 'full',
      triggerOpen: true,
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-truncate]').truncate();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-write-review').click(function (e) {
          e.preventDefault();
          var url = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
            url: url,
            type: 'full',
            triggerOpen: true
          });
        });
      }
    });
  });

  // Add to my list
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-my-list').on('click', function () {
    // check if already has a list
    var productCode = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code');
    if (typeof logEngagement === 'function') {
      logEngagement('PDP My List', 'Click', 'Add to My List Clicked');
    }
    if (pdpProps.defaultMyLists) {
      var favListId = pdpProps.favoriteListId;
      if (!pdpProps.isHeartLimitExceeded && pdpProps.defaultMyLists.indexOf(favListId) >= 0 && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').hasClass(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */].CLASS_NAMES.activated) === false) {
        addToFavorites(productCode, true, function () {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').addClass(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */].CLASS_NAMES.activated);
          addToDefaultMyLists(productCode, true);
        });
      } else {
        addToDefaultMyLists(productCode, false);
      }
    } else {
      addToMyList(productCode);
    }
  });
  function addToDefaultMyLists(productCode, hearted) {
    var data = {
      code: productCode,
      hearted: hearted
    };
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: '/content/favorites/mylist/addProductToDefaultList',
      data: data,
      triggerOpen: true,
      type: 'toast-notification',
      addModifierClass: 'modal--toast-notification--bubble',
      closeButton: false,
      returnFocus: '.js-my-list',
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#manage-lists-link').on('click', function () {
          addToMyList(productCode);
        });
      }
    });
  }
  function addToMyList(productCode) {
    var data = {
      code: productCode
    };
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: window.rcProps.hearts.addToMyListsModalHref + '?mobile=true',
      data: data,
      type: 'toast',
      triggerOpen: true,
      returnFocus: '.js-my-list',
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-change').toggleChange();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-my-list-added').on('click', function () {
          var lists = '';
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-checkbox-saved-list').each(function (i, e) {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).is(':checked')) {
              lists += '&lists=' + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).data('id');
            }
          });
          if (lists === '') {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-create-list-input').is(':visible') && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#new-list').val().trim() == '') {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#creatNewListError').html('Please enter a list name');
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-create-list-input').find('div.field').addClass('is-error');
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#new-list').on('keypress', function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-create-list-input').find('div.field').removeClass('is-error');
              });
              return;
            } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-checkbox-saved-list').length === 0 && !__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-create-list-input').is(':visible')) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#list-not-created-error').removeClass('u-hide');
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-checkbox-saved-list').on('click', function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#list-not-created-error').addClass('u-hide');
              });
              return;
            } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-checkbox-saved-list').length > 0 && !__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-create-list-input').is(':visible')) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#no-list-selected-error').removeClass('u-hide');
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-checkbox-saved-list').on('click', function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#no-list-selected-error').addClass('u-hide');
              });
              return;
            }
          }
          var addToMyListUrl = window.rcProps.hearts.addProductToListHref;
          if (pdpProps.defaultMyLists) {
            addToMyListUrl = '/content/favorites/mylist/addRemoveProductToMyLists';
          }
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: addToMyListUrl + '?product=' + productCode + '&newListName=' + __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#new-list').val() + lists,
            type: 'POST',
            success: function success(listsData) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-create-list-input').find('div.field').removeClass('is-error');
              if (pdpProps.defaultMyLists) {
                if (typeof logEngagement === 'function') {
                  logEngagement('PDP My List', 'Product added', 'Product added to list');
                }
                var favListId = pdpProps.favoriteListId;
                var listIds = '';
                var removedListIds = '';
                if (listsData && _typeof(listsData) === 'object') {
                  if (listsData.addedList) {
                    listIds = listsData.addedList;
                  }
                  if (listsData.removedList) {
                    removedListIds = listsData.removedList;
                  }
                }
                if (listIds.trim() === '' && removedListIds.trim() === '') {
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
                  return;
                }
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                  url: '/content/favorites/mylist/productAddedConfirmation?listIds=' + listIds + '&removedListIds=' + removedListIds,
                  triggerOpen: true,
                  type: 'notification',
                  returnFocus: '.js-my-list'
                });
                if (!pdpProps.isHeartLimitExceeded) {
                  if (lists.indexOf(favListId) < 0 && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').hasClass(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */].CLASS_NAMES.activated)) {
                    addToFavorites(productCode, false, function () {
                      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').removeClass(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */].CLASS_NAMES.activated);
                    });
                  } else if (lists.indexOf(favListId) >= 0 && !__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').hasClass(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */].CLASS_NAMES.activated)) {
                    addToFavorites(productCode, true, function () {
                      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fav-button').addClass(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */].CLASS_NAMES.activated);
                    });
                  }
                }
              } else {
                if (listsData.errorMessage) {
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#creatNewListError').html(listsData.errorMessage);
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-create-list-input').find('div.field').addClass('is-error');
                } else {
                  if (typeof logEngagement === 'function') {
                    logEngagement('PDP My List', 'Product added', 'Product added to list');
                  }
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                    url: window.rcProps.hearts.addToMyListConfirmModalHref + '?product=' + productCode + '&d=' + rcProps.department + '&newListName=' + __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#new-list').val() + lists,
                    type: 'toast',
                    triggerOpen: true
                  });
                }
              }
            }
          });
        });
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-alt-view-video').on('click', function () {
    var module = "Mobile PDP ".concat(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('videoLocation'));
    logEngagement(module, 'Video Click', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('videoId'));
  });

  // attach engagement tracking listeners for FP
  var $fitPredictorRoot = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fp-root');
  $fitPredictorRoot.on('click', '.fp-element', function () {
    logEngagement('Fit Predictor', 'Click');
  }).on('click', '.fp-button-edit', function () {
    logEngagement('Fit Predictor', 'Edit');
  }).on('click', '.fp-button-add-more', function () {
    logEngagement('Fit Predictor', 'Add More');
  });
  var $deliveryUrgencyContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-delivery-urgency-container');
  if ($deliveryUrgencyContainer.length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get('/content/product/mobile/delivery-urgency-messaging?code=' + (codeForInitJs || window.rcProps.pdp.code), function (markup) {
      $deliveryUrgencyContainer.html(markup);
    });
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(window.rcProps.fittingRoomShopModuleHref, __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    code: window.rcProps.pdp.code
  })).done(function (markup) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fitting-room-shop-module').html(markup);
  });
  window.bindSizeGuideEvent();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__modules_revieve_makeup_advisor__["a" /* revieveMakeupAdvisor */])();
  if (codeForInitJs) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_modules_social_proof__["c" /* renderPdpSocialProof */])(codeForInitJs);
  } else {
    window.insertStylisticsImagesByAjax(window.rcProps.pdp.code).then(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_modules_social_proof__["c" /* renderPdpSocialProof */])(window.rcProps.pdp.code);
      if (window.rcProps.revieveEventEnabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__modules_revieve_try_on__["b" /* revieveTryOn */])();
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('revieveScriptLoaded', function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__modules_revieve_try_on__["b" /* revieveTryOn */])();
        });
      }
    });
  }
};
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  initPDPJs();
  function isSizeSelected() {
    if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size').is(':visible')) {
      return true; //one size
    }
    var size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size').val();
    if (size == '') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size').prop('required', 'required');
      return false;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size').removeProp('required');
      return true;
    }
  }
  window.addToBag = function (btn, size) {
    if (typeof size === 'undefined' || size === 'undefined') {
      size = getPdpSize();
      if (size == '' || size === 'unavailable') {
        sizeNotSelectedBeforeAddingToBag = true;
        return;
      }
    }
    var code = getPdpCode(btn);
    console.assert(code, 'Code is invalid when clicking Add To Bag CTA');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__add_to_bag__["a" /* addToBag */])(code, size, function () {
      var $fitPredictorRoot = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fp-root');
      if ($fitPredictorRoot.length) {
        ssp('track', 'addVariantToCart', {
          productId: $fitPredictorRoot.data('productId'),
          quantity: 1,
          variantId: code + '_' + size
        });
      }
    });
  };
  window.addBuyNowProduct = function (btn) {
    var size = getPdpSize();
    if (size == '') {
      return;
    }
    var code = getPdpCode(btn);
    console.assert(code, 'Code is invalid when clicking Buy Now CTA');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__add_to_bag__["b" /* addBuyNowProduct */])(code, size, getFittingRoomItemSize(), btn);
  };
  function getFittingRoomItemSize() {
    var size = '';
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fittingRoomSize').length > 0) {
      size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#fittingRoomSize').find(':selected').val();
    }
    return size;
  }
  function getPdpSize() {
    var size = '';
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-size-options').length > 0) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-size-options input:checked').length == 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').data('select-error-text'));
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').addClass('u-error');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').focus();
        return '';
      }
      size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-size-options input:checked').val();
    } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products').length > 0) {
      // beauty volume options are products displayed as sizes
      size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products option:selected').val();
      if (size == '') {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products').prop('required', 'required');
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products').removeProp('required');
      }
    } else {
      size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size').val();
      if (!isSizeSelected()) {
        return '';
      }
    }
    return size;
  }
  function getPdpCode(btn) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size option:selected').data('code') || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(btn).data('code');
  }
  if (window.rcProps.pdp.preloadColorMarkup) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_modules_preload_markup__["preloadColorMarkup"])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product').find('.product__color select option, .js-size-option'));
  }
  if (window.location.href.indexOf('AddToList=true') > -1) {
    var newURL = location.href.replace('&AddToList=true', '');
    window.history.pushState('object', document.title, newURL);
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('a.js-my-list').length) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('a.js-my-list').click();
    }
  }
  var $influencerBanner = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#influencer-banner');
  if ($influencerBanner.length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(window.rcProps.influencerShareBannerHref, __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      code: window.rcProps.pdp.code
    })).done(function (markup) {
      return $influencerBanner.html(markup);
    });
  }
  var $styleExpertBanner = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#style-expert-banner');
  if ($styleExpertBanner.length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(window.rcProps.styleExpertBannerHref).done(function (markup) {
      return $styleExpertBanner.html(markup);
    });
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(window.rcProps.checkFavoriteHref, __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    code: window.rcProps.pdp.code
  })).done(function (result) {
    var activeHeartClass = window.rcProps && window.rcProps.favoriteActiveClass || 'favorite-button--active';
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#detailsMarkup .js-fav-button').toggleClass(activeHeartClass, result.isFavorite);
  });
  if (window.rcProps && window.rcProps.pdp && window.rcProps.pdp.showMiniTopNav) {
    window.triggerAccordion = function (element) {
      var activeItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#product-info .accordion__item--active');
      var elementHref = element.id;
      if (activeItem.length > 0) {
        var activeContent = activeItem.find('.accordion__content');
        activeItem.removeClass('accordion__item--active');
        activeContent.css({
          height: '',
          display: ''
        });
      }

      // hard-coded values come from UX-18319
      var topOffset = 45;
      var scrollPosition = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("".concat(elementHref)).offset().top - topOffset;
      if (elementHref === '#product-details' || elementHref === '#product-size' || elementHref === '#product-reviews' || elementHref === '#product-ingredients' || elementHref === '#similarItemsMarkup') {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elementHref).click();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
          scrollTop: scrollPosition
        }, 500);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'Mini Top Nav', elementHref, window.rcProps.pdp.code);
      }
      if (activeItem.length && activeItem.height() < 500 && scrollPosition - activeItem.height() > 1000) {
        scrollPosition -= activeItem.height() - topOffset;
      }
    };
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__modules_revieve_try_on__["a" /* revieveAddToBag */])();
});
function placePdpWidgetRow() {
  var row = document.querySelector('.js-pdp-widget-row');
  if (!row) {
    return;
  }
  [document.querySelector('.zelig-widget[id^="zelig-widget-tryon-cta"]'), document.querySelector('.tangiblee-wrapper') || document.querySelector('.tangiblee-cta')].forEach(function (widget) {
    if (!widget) {
      return;
    }
    ['position', 'top', 'bottom', 'left', 'right', 'transform', 'height'].forEach(function (property) {
      widget.style.removeProperty(property);
    });
    row.appendChild(widget);
  });
}
window.placePdpWidgetRow = placePdpWidgetRow;
document.addEventListener('zeligWidgetLoaded', function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-zelig-try-on').removeClass('u-hide');
  placePdpWidgetRow();
});
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel').on('afterChange setPosition', placePdpWidgetRow);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('resize', placePdpWidgetRow);
});
document.addEventListener('WidgetModalOpen', function () {
  logEngagement(window.location.href, 'Zelig', 'PDP widget clicks');
});
document.addEventListener('hue-add-to-cart', function (e) {
  var code = e.detail.variantId;
  var size;
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-products').length) {
    size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-products option[data-code=\"".concat(code, "\"]")).val();
  } else {
    size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select#size').val();
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__add_to_bag__["a" /* addToBag */])(code, size, function () {
    var $fitPredictorRoot = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fp-root');
    if ($fitPredictorRoot.length) {
      ssp('track', 'addVariantToCart', {
        productId: $fitPredictorRoot.data('productId'),
        quantity: 1,
        variantId: code + '_' + size
      });
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hue-cart-menu-header__close').click();
});
document.addEventListener('hue-integration', function () {
  var _e = e,
    detail = _e.detail;
  if (detail.type === 'video-popup-open') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__modules_global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'hue', 'open modal', window.rcProps.pdp.code);
  }
});

/***/ })

},[229]);


// WEBPACK FOOTER //
// dist/pdp.js